import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blood-camp-details',
  templateUrl: './blood-camp-details.component.html',
  styleUrls: ['./blood-camp-details.component.css']
})
export class BloodCampDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
